import React from "react";
import './General.css'
import "bootstrap/dist/css/bootstrap.min.css";
import { Accordion } from "react-bootstrap";
import faqsImage from "../Assets/faqsimage.svg";

const FaqsPeople = () => {
  return (
    <div className="General-page">
      <div className="General-section">
        <h1>Our People</h1>
        <div>
          <Accordion defaultActiveKey="0" flush className="General-background">
            <Accordion.Item eventKey="1">
              <Accordion.Header>
                <h6 className="accordion-text">Who is behind OVest?</h6>
              </Accordion.Header>
              <Accordion.Body className="accordion-bodyText">
                OVest was created as a stem of the OSource Empire, a vision by
                Davidollad (the Founder and CEO). OVest was established to
                enrich you financially. OVest.ng is managed by a team of
                experienced and competent professionals in the finance and
                investment industry within and outside the country to ensure
                optimum returns. You can be rest assured that your investments
                are in safe hands.
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
      </div>
    </div>
  );
};

export default FaqsPeople;
